import { createFileRoute } from '@tanstack/react-router';

import { ApiKeysSection } from '../../../components';

const Page = () => {
  const params = Route.useParams();

  return <ApiKeysSection annuityIntegrationId={params.annuityIntegrationId} />;
};

export const Route = createFileRoute(
  '/carriers/$annuityIntegrationId/api-keys'
)({
  component: Page
});
